import React, { HTMLAttributes } from 'react';
import styles from './Alert.module.scss';

export interface AlertProps extends HTMLAttributes<HTMLDivElement>{
  children?: React.ReactNode
  hasBackground?: boolean,
  variant?: 'danger' | 'info' | 'loading' | 'wait' | 'warning' | 'success',
  size?: 'xs' | 'sm' | 'md' | 'lg',
}

const Alert: React.FC<AlertProps> = ({
  children,
  hasBackground = false,
  variant = 'success',
  size = 'md',
  className,
  ...props
}) => {
  const backgroundClass = hasBackground ? 'background' : '';

  return (
    <div className={`${styles.alert} ${styles[variant]} ${styles[size]} ${styles[backgroundClass]} ${className}`} {...props}>
      { children }
    </div>
  );
};

export default Alert;
